import { getEnvironmentConfig } from '../util/domainDetection';

export function getBffUrl(): string {
  return getEnvironmentConfig().bffUrl;
}

export function getHealthCheckUrl(): string {
  return getEnvironmentConfig().healthCheckUrl;
}

export function getEnvironment() {
  return getEnvironmentConfig().environment;
}

export function isDebugMode(): boolean {
  return getEnvironmentConfig().environment !== 'prod';
}
